import { HttpClient } from '@adapters/HttpClient';
import {
  ApplyPresetResponse,
  ShippingRulePreset,
  ShippingRulePresetsFilters,
  ShippingRulePresetsPage,
  CreateUpdatePresetPayload,
} from '../models/ShippingRulePreset';

export class ShippingRulePresetsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getPresetsPaginated(filters: ShippingRulePresetsFilters = {}): Promise<ShippingRulePresetsPage> {
    const { page = 1, per_page = 15, search, sortBy = 'created_at', sortDirection = 'desc' } = filters;

    const params: Record<string, any> = {
      page,
      per_page,
      ...(search && search.trim() !== '' && { search: search.trim() }),
      ...(sortBy && { 'sorting[column]': sortBy }),
      ...(sortDirection && { 'sorting[direction]': sortDirection }),
    };

    // Solo mostrar loading global para la primera página
    const showGlobalLoading = page === 1;

    const response = await this.httpClient.get<any>('/shipping-rule-presets', params, {}, showGlobalLoading);

    return {
      presets: response.data,
      nextPage: response.meta.current_page < response.meta.last_page ? response.meta.current_page + 1 : undefined,
      hasMore: response.meta.current_page < response.meta.last_page,
      total: response.meta.total,
    };
  }

  async getPresetById(id: number): Promise<ShippingRulePreset> {
    return this.httpClient.get<ShippingRulePreset>(`/shipping-rule-presets/${id}`);
  }

  async createPreset(payload: CreateUpdatePresetPayload): Promise<ShippingRulePreset> {
    return this.httpClient.post<ShippingRulePreset>('/shipping-rule-presets', payload);
  }

  async updatePreset(id: number, payload: Partial<CreateUpdatePresetPayload>): Promise<ShippingRulePreset> {
    return this.httpClient.put<ShippingRulePreset>(`/shipping-rule-presets/${id}`, payload);
  }

  async deletePreset(id: number): Promise<void> {
    await this.httpClient.delete(`/shipping-rule-presets/${id}`);
  }

  async applyPreset(id: number, targetTeamId: number): Promise<ApplyPresetResponse> {
    return this.httpClient.post<ApplyPresetResponse>(`/shipping-rule-presets/${id}/apply`, {
      target_team_id: targetTeamId,
    });
  }
}
